export const cellSize = {
  inline: 20,
  block: 24,
};
